import type {
  ConfigDrivenLivePreviewConfig,
  MarsLivePreviewConfig,
  MarsWidgetContent,
} from 'features/traffic/campaigns/campaign-configs/types/preview.types';
import { AssetStrategy } from 'features/traffic/campaigns/constants';
import type { CampaignConfigProviderCampaignFragment } from 'generated/graphql';
import { generateConfigDrivenFlavorContent } from '../publishing/generate-content';
import type { TContent, TGlobalContent } from '../types';

export const configDrivenCampaignLivePreviewConfig = (
  config: CampaignConfigProviderCampaignFragment,
): MarsLivePreviewConfig<TContent, TGlobalContent> => ({
  generateLivePreviewContent: ({ assetIdToUrlMap, flavor }) => {
    const content = generateConfigDrivenFlavorContent({
      assetIdToUrlMap,
      assetStrategy: AssetStrategy.S3,
      flavor,
    }) as MarsWidgetContent<TContent>;
    // It doesn't matter which ASIN we send here, the uri is required for MARS to call navigation V2 widget.
    return {
      ...content,
      uri: '/dp/B123456789',
    } as MarsWidgetContent<TContent>;
  },
  isMarsWidget: config.livePreviewConfiguration?.isMarsWidget ?? true,
  keepProvidedStyles: config.livePreviewConfiguration?.keepProvidedStyles ?? true,
  needsAuiJs: config.livePreviewConfiguration?.needsAuiJs ?? true,
  supportsPlatformOverride: config.livePreviewConfiguration?.supportsPlatformOverride ?? true,
});

export const buildLivePreviewConfig = (
  config: CampaignConfigProviderCampaignFragment,
): ConfigDrivenLivePreviewConfig<TContent, TGlobalContent> | undefined => {
  if (config.livePreviewConfiguration?.supportsLivePreview === false) return;

  return {
    ...configDrivenCampaignLivePreviewConfig(config),
    campaignConfig: config,
  };
};
